// src/components/IndexPage.js
import { NavLink, Link } from "react-router-dom";

export default function Slider() {
  return (
    <main className="index-page">
      {/* SLIDER SECTION */}
      <section id="home">
        <div
          id="mainCarousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#mainCarousel"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#mainCarousel"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#mainCarousel"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>

          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active">
              <img
                src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1400&q=80"
                className="d-block w-100 slider-img"
                alt="Modern website design"
              />
              <div className="carousel-caption d-none d-md-block text-start">
                <h1 className="fw-bold text-shadow">Modern Web Design</h1>
                <p className="lead">Clean, responsive, and built with React & Bootstrap.</p>
                <NavLink to="/quote" className="btn btn-primary btn-lg rounded-pill">
                  Get a Quote
                </NavLink>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <img
                src="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=1400&q=80"
                className="d-block w-100 slider-img"
                alt="Team collaboration"
              />
              <div className="carousel-caption d-none d-md-block text-start">
                <h1 className="fw-bold text-shadow">Testing & Quality Assurance</h1>
                <p className="lead">We ensure everything runs smoothly before deployment.</p>
                <a href="#services" className="btn btn-outline-light btn-lg rounded-pill">
                  Learn More
                </a>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <img
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1400&q=80"
                className="d-block w-100 slider-img"
                alt="Development showcase"
              />
              <div className="carousel-caption d-none d-md-block text-start">
                <h1 className="fw-bold text-shadow">Deployment & Maintenance</h1>
                <p className="lead">CI/CD pipelines, hosting, and 24/7 monitoring included.</p>
                <a href="#portfolio" className="btn btn-primary btn-lg rounded-pill">
                  View Projects
                </a>
              </div>
            </div>
          </div>

          {/* Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#mainCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#mainCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      {/* Rest of your content goes here */}
    </main>
  );
}
